import { render, staticRenderFns } from "./ModalLocal.vue?vue&type=template&id=1b381a0a&"
import script from "./ModalLocal.vue?vue&type=script&lang=js&"
export * from "./ModalLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports